window.dtMachine = function () {
  const dt_machine = new DataTable('#machine-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#machine-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#machine-datatable', 4); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[3, 'asc']],
    columns: [
      { "data": "index" },
      { "data": "status" },
      { "data": "line" },
      { "data": "machine_code" },
    ],
    columnDefs: [
    ],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
    },
  });

  dtFinalTouch()
}
